import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Shown once per browser session until the day after the event.
const POSTER = {
  id: "christmas-party-2026",
  image: "/pictures/christmas-poster.png",
  alt: "Christmas Party at Our Lady Queen of Martyrs Parish Club, Friday 27th November at 7.30pm. Cost £5. Tickets on sale at all weekend masses.",
  showUntil: new Date("2026-11-28T00:00:00"),
};

export default function EventPosterPopup() {
  const [open, setOpen] = useState(false);
  const storageKey = `poster-seen-${POSTER.id}`;

  useEffect(() => {
    if (new Date() >= POSTER.showUntil) return;
    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch {}
    setOpen(true);
  }, [storageKey]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  function close() {
    try {
      sessionStorage.setItem(storageKey, "1");
    } catch {}
    setOpen(false);
  }

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
      onClick={close}
    >
      <div
        className="relative bg-white rounded-lg shadow-lg max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Christmas Party"
      >
        <button
          onClick={close}
          aria-label="Close"
          className="absolute -top-3 -right-3 bg-white text-black rounded-full w-9 h-9 shadow-md text-xl leading-none hover:bg-black hover:text-white transition"
        >
          &times;
        </button>
        <img
          src={POSTER.image}
          alt={POSTER.alt}
          className="w-full max-h-[75vh] object-contain rounded px-4 pt-6"
        />
        <div className="p-4 text-center">
          <Link
            to="/news-and-events"
            onClick={close}
            className="inline-block border border-black text-black px-4 py-1 rounded hover:bg-black hover:text-white transition"
          >
            See all events
          </Link>
        </div>
      </div>
    </div>
  );
}
